/**
 * @fileoverview DashboardCharts - Container for dashboard chart visualizations
 * Displays RunsOverTime and StatusDistribution charts in refined card wrappers
 */
import { ChartCard, RunsOverTimeChart, StatusDistributionChart } from '@/components/charts'
import type { RunsOverTimeDataPoint } from '@/components/charts/RunsOverTimeChart'
import type { StatusDataPoint } from '@/components/charts/StatusDistributionChart'

export interface DashboardChartsData {
  runsOverTime: RunsOverTimeDataPoint[]
  statusDistribution: StatusDataPoint[]
}

export interface DashboardChartsProps {
  data: DashboardChartsData
  isLoading?: boolean
}

export function DashboardCharts({ data, isLoading }: DashboardChartsProps) {
  return (
    <div 
      className="grid grid-cols-1 lg:grid-cols-2 gap-4"
      role="region"
      aria-label="Dashboard charts"
    >
      <ChartCard
        title="Runs Over Time"
        description="Activity trend for the past 7 days"
        isLoading={isLoading}
      >
        <RunsOverTimeChart 
          data={data.runsOverTime} 
          height={280}
          showBreakdown
        />
      </ChartCard>

      <ChartCard
        title="Status Distribution"
        description="Breakdown of run outcomes"
        isLoading={isLoading}
      >
        <StatusDistributionChart 
          data={data.statusDistribution}
          height={280}
          variant="donut"
          showCenterLabel
          centerLabelText="Total"
        />
      </ChartCard>
    </div>
  )
}
